routesConfig.$inject = ['$stateProvider'];

function routesConfig($stateProvider){
  $stateProvider
    .state('home.quotations', {
      url: "/pagos-y-anticipos/cotizaciones/{orderServiceId}",
      template: `<quotations sh-ctrl="shCtrl"></quotations>`
    });
}

export default routesConfig;



/** WEBPACK FOOTER **
 ** C:/xampp/htdocs/payomaro-pay-zone/www/components/payments-advances/quotations/quotations.config.js
 **/